import { singleline } from "@core/foundation/string";
import { apiEndpoint, internalApi } from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";
import { UserRoleSchema, UserScopesSchema } from "@platform/core/models";

import { ACCOUNT_SERVICE } from "../config/index.ts";

export const accountInternalApi = internalApi(
  { domain: API_DOMAIN, path: `${ACCOUNT_SERVICE.LABEL}/int` },
  {
    signInAsServiceAccount: apiEndpoint({
      body: z.object(
        {
          role: UserRoleSchema,
          scopes: UserScopesSchema.optional(),
          serviceAccount: z.safeId(),
        },
        {
          role: "The role to sign the service account in as",
          scopes: singleline`
            The API scopes the token grants, which the service account must
            allow; none when omitted
          `,
          serviceAccount: "The identifier of the service account to sign in as",
        },
      ),
      response: z.object(
        { authToken: z.string() },
        { authToken: "The auth token issued to the service account" },
      ),
    }),
  },
);
